import PropTypes from "prop-types";
// @mui
import { styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar, IconButton } from "@mui/material";
// utils
import { bgBlur } from "../../../utils/cssStyles";
// components
import Iconify from "../../../components/iconify";
//
import Searchbar from "./Searchbar";
import AccountPopover from "./AccountPopover";
import NotificationsPopover from "./NotificationsPopover";
import ShopCartHeaderButton from "./ShopCartHeaderButton";
import { useSelector } from "react-redux";
import { selectEffectiveRoles } from "../../../features/rolePreview/rolePreviewSlice";
import { ROLES_LIST } from "../../../features/roles/roles.config";
import MemberViewSwitch from "../../../features/rolePreview/MemberViewSwitch";

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = "3vh";

const HEADER_DESKTOP = "3vh";

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: "none",
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const roles = useSelector(selectEffectiveRoles);
  const isMitglied =
    Array.isArray(roles) &&
    roles.includes(ROLES_LIST.Mitglied) &&
    !roles.some((r) =>
      [
        ROLES_LIST.User,
        ROLES_LIST.Editor,
        ROLES_LIST.Admin,
        ROLES_LIST.SuperAdmin,
      ].includes(r)
    );

  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: "text.primary",
            display: { lg: "none" },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        {!isMitglied && <Searchbar />}
        <MemberViewSwitch />
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          sx={{
            mt: 1,
          }}
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <ShopCartHeaderButton />
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
